<div class="project-{{selectedProject}}">
    <p-confirmDialog [baseZIndex]="10000" [closable]="false" [closeOnEscape]="false" [style]="{width: '500px'}" header="Uppdatering" icon="fas fa-cogs"
                     key="triggerUpdateDialog"></p-confirmDialog>

    <p-toast position="bottom-right"></p-toast>

    <p-confirmDialog
            acceptLabel="Ja"
            header="Bekräfta"
            icon="pi pi-exclamation-triangle"
            rejectLabel="Nej"
    ></p-confirmDialog>


    <div *ngIf="appLayout == 'minimal'" class="mx-2 pb-5 pt-5">
        <!--<mat-toolbar class="main-toolbar">

            <div *ngIf="currentUser" class="profile-toplink d-flex cursor-pointer">
                <a (click)="menu.toggle($event)" class="text">
                    <span class="d-none d-sm-inline">{{ currentUser.firstname }} {{ currentUser.surname }}</span>
                    <img src="./assets/images/blank-profile-picture.svg"/>
                </a>
                <p-menu #menu [model]="avatarMenu" [popup]="true" appendTo="body"></p-menu>
            </div>
            <div></div>
        </mat-toolbar>
        -->
        <dd-not-found></dd-not-found>
        <router-outlet></router-outlet>
    </div>


</div>
